import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    firstName: checkRequiredText(settings),
    lastName: checkRequiredText(settings),
    emailAddress: Yup.string()
        .email("Bitte geben Sie eine gültige E-Mail-Adresse an")
        .required("Angabe ist erforderlich"),
    street: checkRequiredText(settings),
    postalCode: checkRequiredText(settings),
    city: checkRequiredText(settings),
    phoneNumber: Yup.string()
        .matches(RegExp(settings.applicationPhoneNumberRegex), "Ungültige Telefonnummer")
        .required("Angabe ist erforderlich"),
});

export const NameAndContactSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formFirstName">
                    <Form.Label>Vorname*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Vorname eingeben"
                        type="text"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.firstName && !errors.firstName}
                        isInvalid={touched.firstName && errors.firstName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.firstName}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formLastName">
                    <Form.Label>Name*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Nachname eingeben"
                        type="text"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.lastName && !errors.lastName}
                        isInvalid={touched.lastName && errors.lastName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.lastName}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>E-Mail*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="E-Mail eingeben"
                    type="email"
                    name="emailAddress"
                    value={values.emailAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.emailAddress && !errors.emailAddress}
                    isInvalid={touched.emailAddress && errors.emailAddress}
                    maxLength={settings.emailInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formStreet">
                <Form.Label>Straße*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Straße eingeben"
                    type="text"
                    name="street"
                    value={values.street}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.street && !errors.street}
                    isInvalid={touched.street && errors.street}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.street}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPostalCode">
                <Form.Label>PLZ*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Postleitzahl eingeben"
                    type="text"
                    name="postalCode"
                    value={values.postalCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.postalCode && !errors.postalCode}
                    isInvalid={touched.postalCode && errors.postalCode}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.postalCode}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formCity">
                <Form.Label>Ort*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Ort eingeben"
                    type="text"
                    name="city"
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.city && !errors.city}
                    isInvalid={touched.city && errors.city}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.city}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPhoneNumber">
                <Form.Label>Telefon*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Telefon eingeben"
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.phoneNumber && !errors.phoneNumber}
                    isInvalid={touched.phoneNumber && errors.phoneNumber}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.phoneNumber}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};